import type { SVGProps } from 'react'

const Sun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="10" cy="10" r="3.5" />
    <path d="M10 1.667v1.666M10 16.667v1.666M3.108 3.108l1.179 1.179M15.713 15.713l1.179 1.179M1.667 10h1.666M16.667 10h1.666M3.108 16.892l1.179-1.179M15.713 4.287l1.179-1.179" />
  </svg>
)

export default Sun
